import { render } from "./TestDetail.vue?vue&type=template&id=1cff32ac&scoped=true&ts=true"
import script from "./TestDetail.vue?vue&type=script&lang=ts"
export * from "./TestDetail.vue?vue&type=script&lang=ts"

import "./TestDetail.vue?vue&type=style&index=0&id=1cff32ac&lang=css"
import "./TestDetail.vue?vue&type=style&index=1&id=1cff32ac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cff32ac"]])

export default __exports__